import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteAccessoriesProductModel } from 'src/app/models/product/accessories.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-accessories-products-deleted',
  templateUrl: './accessories-products-deleted.component.html',
  styleUrls: ['./accessories-products-deleted.component.css']
})
export class AccessoriesProductsDeletedComponent implements OnInit {
  Loader: boolean = false;
  ProductId: string;
  deleteAccessoriesProduct: DeleteAccessoriesProductModel = new DeleteAccessoriesProductModel();
  constructor(private modalService: NgbModal, private productService: ProductService, private alertify: AlertifyService) { }

  ngOnInit() {
    this.ProductId = this.ProductId;
  }

  onCancel() {
    this.modalService.dismissAll();
  }

  deleteAccessoriesProducts() {
    this.Loader = true;
    this.deleteAccessoriesProduct.AccessoriesProductIds = this.ProductId.toString();
    this.productService.DeleteAccessoriesProducts(this.deleteAccessoriesProduct)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        if (responseBody.isSuccess) {
          this.modalService.dismissAll();
          this.alertify.success(responseBody.responseMessage);
          this.Loader = false;
        } else {
          this.Loader = false;
        }
      })
  }
}
